import { GET_REGION_DROP_DOWN_LIST, SET_REGION_DROP_DOWN_LIST,GET_REGIONS, SET_REGIONS } from "./RegionType";

const getRegionDropDown = () => ({
    type: GET_REGION_DROP_DOWN_LIST,
});

const setRegionDropDown = (response: any) => ({
    type: SET_REGION_DROP_DOWN_LIST,
    response
});

const getRegion = () => ({
    type: GET_REGIONS,
});

const setRegion = (regionDropDownList: any) => ({
    type: SET_REGIONS,
    regionDropDownList
});


export {
    getRegionDropDown,
    setRegionDropDown,
    getRegion,
    setRegion
}
